import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { ApolloQueryResult } from '@apollo/client/core';
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib';
import { merge } from 'lodash';
import { combineLatest, map, Observable, switchMap, tap, timer } from 'rxjs';

import { CollectionsService } from '../data/services/collections.service';
import { Request } from '../data/services/request-enum';

@Injectable({ providedIn: 'root' })
export class I18nDataLoadingService {
  constructor(
    private collectionsService: CollectionsService,
    private httpClient: HttpClient,
    private injector: Injector
  ) {}

  getTranslation(lang: string, force: boolean = false): Observable<any> {
    const KEY = `/${lang}`;
    if (isScullyGenerated() && !force) {
      return timer(1).pipe(switchMap(() => this.injector.get(TransferStateService).getState<ApolloQueryResult<any>>(KEY)));
    } else {
      return combineLatest([
        this.httpClient.get(`/assets/locales/${lang}.json`),
        timer(1).pipe(switchMap(() => this.collectionsService.query<any>(Request.I18N, { locale: lang }))),
      ]).pipe(
        map(([a, b]) => merge(a, b)),
        tap(data => this.injector.get(TransferStateService).setState(KEY, data))
      );
    }
  }
}
